/* eslint-disable no-unused-vars */
import React from 'react'
import { Box, Typography } from '@mui/material'
import { navigationBarStyles } from '../../styles/classes/MobilePreviewClasses'
import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons'

const MobileNavigationBar = ({
  pendingTasks,
  completePercentage,
  onPreviewModeSwitch,
  isPreviewMode,
  formName
}) => {
  const { t } = useTranslation()
  const { classes } = navigationBarStyles()
  return (
    <Box className={classes.container}>
      <div className={classes.secondaryContainer}>
        <Box onClick={onPreviewModeSwitch}>
          <FontAwesomeIcon icon={faChevronLeft} className={classes.backIcon} />
        </Box>
        <div className={classes.textContainer}>
          {pendingTasks === 0 && !isPreviewMode && (
            <Box className={classes.allsetMessageContainer}>
              <Typography className={classes.taskCounterText}>
                {t('mobile_preview.all_set')}
              </Typography>
              <FontAwesomeIcon icon={faCheck} style={{ fontSize: '12px' }} />
            </Box>
          )}
          {pendingTasks > 0 && !isPreviewMode && (
            <Typography className={classes.pendingTaskCounterText}>
              {t('mobile_preview.tasks_remaining', { number: pendingTasks })}
            </Typography>
          )}
          {!isPreviewMode && (
            <Typography className={classes.serviceFormTitle}>
              {t('mobile_preview.percentage_complete', {
                percentage: completePercentage
              }).toUpperCase()}
            </Typography>
          )}
          {isPreviewMode && (
            <Typography className={classes.allsetMessageContainer}>
              {formName}
            </Typography>
          )}
          {isPreviewMode && (
            <Typography className={classes.authorizationText}>
              {t('mobile_preview.review_and_authorize')}
            </Typography>
          )}
        </div>
      </div>
    </Box>
  )
}

export default MobileNavigationBar
